function defineSelectInput() {
  const selects = document.querySelectorAll("fieldset > select")
  const facets = document.querySelectorAll('facet-filters-form form')
  
  for (const select of selects) {
    const div = document.createElement("div");
    const header = document.createElement("div");
    const datalist = document.createElement("datalist");
    const optgroups = select.querySelectorAll("optgroup");
    const span = document.createElement("span");
    const options = select.options;
    const parent = select.parentElement;
    const multiple = select.hasAttribute("multiple");
    
    function onSortClick(e) {
      const disabled = false
      select.value = this.dataset.value;
      span.innerText = this.dataset.label;
      
      if (disabled) return;
      if (multiple) {
        if (e.shiftKey) {
          const checked = e.hasAttribute("data-checked");
          if (checked) {
            e.removeAttribute("data-checked");
          } else {
            e.setAttribute("data-checked", "");
          }
        } else {
          const options = div.querySelectorAll(".option");
          for (let i = 0; i < options.length; i++) {
            const option = options[i];
            option.removeAttribute("data-checked");
          }
          this.setAttribute("data-checked", "");
        }
      }
  
      e.target.closest('form').submit()
    }
  
    function onSortKeyup(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.keyCode === 13) {
        this.click();
      }
    }
  
    div.classList.add("custom-select-select");
    header.classList.add("custom-select-header");
    div.tabIndex = 1;
    select.tabIndex = -1;
  
    setTimeout(function() {
      span.innerText = select.options[select.selectedIndex].text;
      header.appendChild(span);
    }, 0)
  
    for (const attribute of select.attributes) {
      div.dataset[attribute.name] = attribute.value;
    }
    for (let i = 0; i < options.length; i++) {
      const option = document.createElement("div");
      const label = document.createElement("div");
      const o = options[i];
      for (const attribute of o.attributes) {
        option.dataset[attribute.name] = attribute.value;
      }
      option.classList.add("custom-select-option");
      label.classList.add("custom-select-label");
      label.innerText = o.label;
      option.dataset.value = o.value;
      option.dataset.label = o.label;
      option.onclick = onSortClick;
      option.onkeyup = onSortKeyup;
      option.tabIndex = i + 1;
      option.appendChild(label);
      datalist.appendChild(option);
    }
    div.appendChild(header);
    for (const o of optgroups) {
      const optgroup = document.createElement("div");
      const label = document.createElement("div");
      const options = o.querySelectorAll("option");
  
      Object.assign(optgroup, o);
      optgroup.classList.add("custom-select-optgroup");
      label.classList.add("custom-select-label");
      label.innerText = o.label;
      optgroup.appendChild(label);
      div.appendChild(optgroup);
      for (const o of options) {
        const option = document.createElement("div");
        const label = document.createElement("div");
  
        for (const attribute of o.attributes) {
          option.dataset[attribute.name] = attribute.value;
        }
        option.classList.add("custom-select-option");
        label.classList.add("custom-select-label");
        label.innerText = o.label;
        option.tabIndex = i + 1;
        option.dataset.value = o.value;
        option.dataset.label = o.label;
        option.onclick = onSortClick;
        option.onkeyup = onSortKeyup;
        option.tabIndex = i + 1;
        option.appendChild(label);
        optgroup.appendChild(option);
      }
    }
  
    div.onclick = (e) => {
      e.preventDefault();
    };
  
    parent.insertBefore(div, select);
    header.appendChild(select);
    div.appendChild(datalist);
  
    div.onclick = (e) => {
      if (!multiple) {
        const open = div.hasAttribute("data-open");
        e.stopPropagation();
        if (open) {
          div.removeAttribute("data-open");
        } else {
          div.setAttribute("data-open", "");
        }
      }
    };
  
    div.onkeyup = (event) => {
      event.preventDefault();
      if (event.keyCode === 13) {
        div.click();
      }
    };
  
    document.addEventListener("click", (e) => {
      if (div.hasAttribute("data-open")) {
        div.removeAttribute("data-open");
      }
    });
  
    const width = Math.max(
      ...Array.from(options).map((e) => {
        span.innerText = e.label;
        return div.offsetWidth;
      }),
    );
  
    // div.style.width = `calc(${width}px + 1rem)`;
    div.style.minWidth = 'max-content'
  }
}

defineSelectInput();